'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _iterator2 = require('babel-runtime/core-js/symbol/iterator');

var _iterator3 = _interopRequireDefault(_iterator2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _config = require('config/config');

var config = _interopRequireWildcard(_config);

var _components2 = require('components');

var _modal = require('redux/actions/modal');

var _payment = require('redux/actions/payment');

var _translate_pipo = require('redux/actions/translate_pipo');

var _personal = require('redux/actions/personal');

var _error = require('redux/actions/error');

var _helpers = require('helpers');

var _utils = require('helpers/utils');

var _LocalStorageProxy = require('ibonus/LocalStorageProxy');

var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);

var _modal_type = require('redux/actions/modal_type');

var _PaymentStatus = require('helpers/Order/PaymentStatus');

var _PaymentStatus2 = _interopRequireDefault(_PaymentStatus);

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

var _IBonusError = require('api/IBonusError');

var _IBonusError2 = _interopRequireDefault(_IBonusError);

var _reactSAlert = require('react-s-alert');

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    PaymentList: {
        displayName: 'PaymentList'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Order/PaymentList/index.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var pickupAndCourierSlugs = [_utils.PAY_PICKUP_SLUG, _utils.PAY_COURIER_SLUG];

var PaymentList = _wrapComponent('PaymentList')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        langList: state.translate_pipo.list,
        processInput: state.payment.processInput,
        buyInCreditActive: state.setting.buyInCreditActive,
        buyInCredit: state.setting.buyInCredit,
        state: state,
        lang: state.lang,
        user: state.auth.user,
        currency: state.currency
    };
}, {
    push: _reactRouterRedux.push,
    showModal: _modal.showModal,
    hide: _modal.hide,
    throwAlertAction: _error.error,
    getLang: _translate_pipo.getLang,
    loadProcessInput: _payment.loadProcessInput,
    setOrder: _personal.setOrder,
    setPayOrder: _personal.setPayOrder,
    setCustomPayment: _payment.setCustomPayment,
    rePaymentByOrder: _payment.rePaymentByOrder,
    resetProcessInput: _payment.resetProcessInput,
    showBuyInCreditModal: _modal_type.showBuyInCreditModal
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(PaymentList, _Component);

    function PaymentList(props, context) {
        (0, _classCallCheck3.default)(this, PaymentList);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PaymentList.__proto__ || (0, _getPrototypeOf2.default)(PaymentList)).call(this, props, context));

        _this.paymentStatusHelper = null;

        _this.onPay = function () {
            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref$clientCommentary = _ref.clientCommentary,
                clientCommentary = _ref$clientCommentary === undefined ? '' : _ref$clientCommentary,
                _ref$delivery_address = _ref.delivery_address,
                delivery_address = _ref$delivery_address === undefined ? '' : _ref$delivery_address,
                _ref$discountSum = _ref.discountSum,
                discountSum = _ref$discountSum === undefined ? 0 : _ref$discountSum,
                _ref$couponId = _ref.couponId,
                couponId = _ref$couponId === undefined ? null : _ref$couponId,
                _ref$couponToken = _ref.couponToken,
                couponToken = _ref$couponToken === undefined ? null : _ref$couponToken,
                _ref$customerCouponId = _ref.customerCouponId,
                customerCouponId = _ref$customerCouponId === undefined ? null : _ref$customerCouponId,
                _ref$preloadCallback = _ref.preloadCallback,
                preloadCallback = _ref$preloadCallback === undefined ? null : _ref$preloadCallback,
                _ref$customFields = _ref.customFields,
                customFields = _ref$customFields === undefined ? null : _ref$customFields,
                _ref$childOrders = _ref.childOrders,
                childOrders = _ref$childOrders === undefined ? null : _ref$childOrders,
                _ref$captcha = _ref.captcha,
                captcha = _ref$captcha === undefined ? null : _ref$captcha;

            var _this$props$order = _this.props.order,
                id = _this$props$order.id,
                payment_in_id = _this$props$order.payment_in_id;

            if (_this.props.order.sum === '0.00000000') {
                _this.props.setPayOrder(id, clientCommentary, _this.state.selectedSlug, delivery_address, discountSum, couponId, couponToken, customerCouponId, customFields, childOrders, captcha).then(function (result) {
                    _this.props.setCustomPayment();
                    _this.props.hide();
                    _this.props.push('/payment-order/' + _this.props.order.id);
                });
            } else if (_this.isBuyInCreditPayMethod()) {
                _this.props.order.discount_sum = discountSum;
                _this.props.setPayOrder(id, clientCommentary, _this.state.selectedSlug, delivery_address, discountSum, couponId, couponToken, customerCouponId, customFields, childOrders, captcha).then(function (result) {
                    //this.props.createFormBuyInCredit();
                    // this.createFormBuyInCredit();
                    //this.props.showBuyInCreditModal(this.props.order, this.props.lang['onlineShop.availableServiceIn.buyInCredit'], this.props.buyInCredit);
                    if (preloadCallback !== null) {
                        preloadCallback();
                        _this.props.hide();
                        _this.props.push('/payment-order/' + _this.props.order.id);
                    } else {
                        _this.props.hide();
                        _this.props.push('/payment-order/' + _this.props.order.id);
                    }
                });
                return;
            } else if (!_this.isUserHaveSelectedPayMethod()) {
                if (preloadCallback !== null) {
                    preloadCallback();
                }
                return;
            } else if (_this.paymentStatusHelper.isCanceled()) {
                if (preloadCallback !== null) {
                    preloadCallback();
                }
                _this.throwOrderCanceledAlert();
            } else if (_this.isSelectedIBonusPayMethod()) {
                _this.props.setPayOrder(id, clientCommentary, null, delivery_address, discountSum, couponId, couponToken, customerCouponId, customFields, childOrders, captcha).then(function (result) {
                    if (preloadCallback !== null) {
                        preloadCallback();
                    }
                    _this.props.setCustomPayment();
                    _this.props.showModal({
                        title: _this.props.lang['store.payment_list.i-bonus_payment'],
                        content: _react3.default.createElement(_components2.IBonusPayment, {
                            orderId: id,
                            operationId: result.payment_in_id,
                            callbackPay: _this.callbackPay,
                            setStepConfirm: _this.setStepConfirm,
                            stepConfirm: _this.state.stepConfirm
                        }),
                        modalType: 'payment-ibonis'
                    });
                });
            } else if (_this.isSelectedPickupAndCourierPayMethod()) {
                _this.props.setPayOrder(id, clientCommentary, _this.state.selectedSlug, delivery_address, discountSum, couponId, couponToken, customerCouponId, customFields, childOrders, captcha).then(function (result) {
                    _this.props.setCustomPayment();
                    _this.props.loadProcessInput(result.payment_in_id, _this.state.selectedSlug, _this.state.additionalFieldName, _this.state.additionalFieldText).then(function (result) {
                        var status = !!result.status;
                        if (status && result.result && (0, _keys2.default)(result.result).length > 0 && (0, _keys2.default)(_this.props.processInput).length !== (0, _keys2.default)(result.result).length) {
                            var url = '/payment-order/' + _this.props.order.id + '?pi_type=' + _this.state.selectedSlug;
                            if (_this.state.additionalFieldName && _this.state.additionalFieldText) {
                                url += '&pi_name=' + _this.state.additionalFieldName;
                                url += '&pi_value=' + _this.state.additionalFieldText;
                            }

                            _this.props.push(url);
                        } else {
                            if (preloadCallback !== null) {
                                preloadCallback();
                            }
                            var message = '',
                                title = '',
                                code = 0,
                                trace = '';
                            if ((0, _isString2.default)(result.result)) {
                                message = result.result;
                                title = result.result;
                            } else if (result.hasOwnProperty('user_msg')) {
                                message = result.user_msg;
                                title = result.user_msg;
                            } else {
                                message = result.result.error.message || '';
                                title = result.result.title || 0;
                                code = result.result.code || 0;
                                trace = result.result.error.trace || '';
                            }
                            message = _this.props.lang[message] || message;
                            title = _this.props.lang[title] || title;
                            _reactSAlert2.default.error(message, { position: 'top-right', effect: 'slide', timeout: 3000 });
                            // throw new IBonusError({
                            //     message:message,
                            //     title: title,
                            //     code: code,
                            //     trace: trace,
                            // });
                        }
                    });
                });
            } else if (_this.isSelectedPaymentNonInteractive()) {
                if (_this.state.additionalFieldIsRequired && _this.state.additionalFieldText.length === 0) {
                    if (_this._refAdditionalField) {
                        _this._refAdditionalField.focus();
                    }
                    return;
                }
                _this.props.setPayOrder(id, clientCommentary, null, delivery_address, discountSum, couponId, couponToken, customerCouponId, customFields, childOrders, captcha).then(function (result) {
                    _this.props.setCustomPayment();
                    _this.props.loadProcessInput(result.payment_in_id, _this.state.selectedSlug, _this.state.additionalFieldName, _this.state.additionalFieldText).then(function (result) {
                        var status = !!result.status;
                        if (status && result.result && (0, _keys2.default)(result.result).length > 0 && (0, _keys2.default)(_this.props.processInput).length !== (0, _keys2.default)(result.result).length) {
                            var url = '/payment-order/' + _this.props.order.id + '?pi_type=' + _this.state.selectedSlug;
                            if (_this.state.additionalFieldName && _this.state.additionalFieldText) {
                                url += '&pi_name=' + _this.state.additionalFieldName;
                                url += '&pi_value=' + _this.state.additionalFieldText;
                            }
                            _this.props.push(url);
                        } else {
                            if (preloadCallback !== null) {
                                preloadCallback();
                            }
                            var message = '',
                                title = '',
                                code = 0,
                                trace = '';
                            if ((0, _isString2.default)(result.result)) {
                                message = result.result;
                                title = result.result;
                            } else if (result.hasOwnProperty('user_msg')) {
                                message = result.user_msg;
                                title = result.user_msg;
                            } else {
                                message = result.result.error.message || '';
                                title = result.result.title || 0;
                                code = result.result.code || 0;
                                trace = result.result.error.trace || '';
                            }
                            message = _this.props.lang[message] || message;
                            title = _this.props.lang[title] || title;
                            _reactSAlert2.default.error(message, { position: 'top-right', effect: 'slide', timeout: 3000 });
                            // throw new IBonusError({
                            //     message:message,
                            //     title: title,
                            //     code: code,
                            //     trace: trace,
                            // });
                        }
                    });
                });
            } else if (_this.paymentStatusHelper.isOutdated) {
                _this.props.rePaymentByOrder(id, function (newOrder) {
                    _this.props.setPayOrder(id, clientCommentary, null, discountSum, couponId, couponToken, customerCouponId, customFields, childOrders, captcha).then(function (result) {
                        window.location = (0, _utils.getPipoPageOnProcessInput)(newOrder.payment_in_id, _this.state.selectedSlug, _this.state.additionalFieldName, _this.state.additionalFieldText, newOrder.order_id, _this.props.currency.code);
                    });
                });
            } else if (_this.paymentStatusHelper.isPayActionAvaliable()) {
                _this.props.setPayOrder(id, clientCommentary, null, delivery_address, discountSum, couponId, couponToken, customerCouponId, customFields, childOrders, captcha).then(function (result) {
                    window.location = (0, _utils.getPipoPageOnProcessInput)(result.payment_in_id, _this.state.selectedSlug, _this.state.additionalFieldName, _this.state.additionalFieldText, id, _this.props.currency.code);
                });
            }
        };

        _this.callbackPay = function () {
            _this.props.hide();
            _this.props.push('/payment-order/' + _this.props.order.id);
        };

        _this.handleChange = function (event) {
            _this.setState({
                'selectedSlug': event.target.value,
                additionalFieldText: '',
                'selectedSlugText': event.target.getAttribute('data-text'),
                'selectedSlugImg': event.target.getAttribute('data-img')
            });

            _this.props.disButton(event.target.value || false);

            _props$payments$entri = _this.props.payments.entries();

            if (!(_props$payments$entri && (typeof _props$payments$entri[_iterator3.default] === 'function' || Array.isArray(_props$payments$entri)))) {
                throw new TypeError('Expected _props$payments$entri to be iterable, got ' + _inspect(_props$payments$entri));
            }

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(_props$payments$entri), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _props$payments$entri;

                    var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                        index = _step$value[0],
                        payment = _step$value[1];

                    if (payment.slug === event.target.value) {
                        _this.setState({ 'selectedPaymentIndex': index });
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var element = document.getElementsByClassName('select_input_wrap');
            element = element[0];
            if (!element) {
                return;
            }
            var classString = 'select_input_wrap';
            element.className = classString;
        };

        _this.handleChangeAdditionalField = function (value) {
            _this.setState({
                additionalFieldText: value
            });
        };

        _this.handleShowAdditionalField = function (isRequired, fieldName) {
            if (!(typeof isRequired === 'boolean')) {
                throw new TypeError('Value of argument "isRequired" violates contract.\n\nExpected:\nboolean\n\nGot:\n' + _inspect(isRequired));
            }

            if (!(typeof fieldName === 'string')) {
                throw new TypeError('Value of argument "fieldName" violates contract.\n\nExpected:\nstring\n\nGot:\n' + _inspect(fieldName));
            }

            _this.setState({
                additionalFieldName: fieldName,
                additionalFieldIsRequired: isRequired
            });
        };

        _this.setStepConfirm = function (confirm) {
            _this.setState({
                stepConfirm: confirm
            });
        };

        var order = props.order;

        _this.paymentStatusHelper = new _PaymentStatus2.default(order.paymentStatus.id);
        var slug = '';
        var slugText = '';
        var slugImg = '';
        if (_this.props.payments.length > 0) {
            slugText = _this.props.lang['store.payment_list.select_payment_method'];
        }
        if (_this.props.buyInCreditActive && _this.props.order.sum <= 500000 && _this.props.order.sum >= 3000) {
            var buyInCreditOrder = _LocalStorageProxy2.default.getItem('buy_in_credit');
            if (buyInCreditOrder === 'true') {
                slug = 'buy_in_credit';
                slugText = _this.props.lang['common.service_in.buy_in_credit'];
                slugImg = config.apiHost + '/static_files/static/images/services/paytype.jpg';
                _this.props.disButton('buy_in_credit');
            }
        } else if (_this.props.payments.length === 1) {
            slug = _this.props.payments[0].slug;
            slugText = _this.props.lang['onlineShop.buyInCredit.service'];
            slugText = _this.props.payments[0].lang_data_rus;
            if (_this.props.currency.code === 'GBP' || _this.props.currency.code === 'USD' || _this.props.currency.code === 'EUR' || _this.props.currency.code === 'TRY' || _this.props.currency.code === 'AED') {
                slugText = _this.props.payments[0].lang_data_eng;
            }
            slugImg = _this.props.payments[0].icon;
            _this.props.disButton(_this.props.payments[0].slug);
        }

        _this.state = {
            selectedSlug: slug,
            selectedSlugText: slugText,
            selectedSlugImg: slugImg,
            selectedPaymentIndex: 0,
            additionalFieldText: '',
            additionalFieldName: '',
            additionalFieldIsRequired: false,
            stepConfirm: false
        };

        _this.props.getInstance(_this);
        return _this;
    }

    (0, _createClass3.default)(PaymentList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // предварительная предзагрузка языка
            if (!this.props.langList.hasOwnProperty('pay.alfa_label')) {
                this.props.getLang(this.props.currency.lang.slug);
            }

            this._refAdditionalField = null;
            this.props.resetProcessInput();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var nextOrder = nextProps.order;
            var order = this.props.order;


            if (order.paymentStatus.id !== nextOrder.paymentStatus.id) {
                this.paymentStatusHelper = new _PaymentStatus2.default(nextOrder.paymentStatus.id);
            }

            if (nextProps.processInput && (0, _keys2.default)(nextProps.processInput).length > 0 && (0, _keys2.default)(this.props.processInput).length !== (0, _keys2.default)(nextProps.processInput).length) {
                var url = '/payment-order/' + this.props.order.id + '?pi_type=' + nextProps.processInput.slug;

                if (this.state.additionalFieldName && this.state.additionalFieldText) {
                    url += '&pi_name=' + this.state.additionalFieldName;
                    url += '&pi_value=' + this.state.additionalFieldText;
                }

                this.props.push(url);
            }
        }

        //noinspection JSAnnotator

    }, {
        key: 'isUserHaveSelectedPayMethod',
        value: function isUserHaveSelectedPayMethod() {
            return !!this.state.selectedSlug;
        }
    }, {
        key: 'isBuyInCreditPayMethod',
        value: function isBuyInCreditPayMethod() {
            return this.state.selectedSlug === 'buy_in_credit';
        }
    }, {
        key: 'isSelectedIBonusPayMethod',
        value: function isSelectedIBonusPayMethod() {
            return _components2.IBonusPayment.checkSlug(this.state.selectedSlug);
        }
    }, {
        key: 'isSelectedPickupAndCourierPayMethod',
        value: function isSelectedPickupAndCourierPayMethod() {
            return pickupAndCourierSlugs.includes(this.state.selectedSlug);
        }
    }, {
        key: 'isSelectedPaymentNonInteractive',
        value: function isSelectedPaymentNonInteractive() {
            var selectedPayment = this.props.payments[this.state.selectedPaymentIndex];
            return selectedPayment && selectedPayment.non_interactive;
        }
    }, {
        key: 'throwOrderCanceledAlert',
        value: function throwOrderCanceledAlert() {
            if (this.paymentStatusHelper.isCanceled()) {
                this.props.throwAlertAction(this.props.lang[this.props.order.paymentStatus.lang_data]);
            }
        }
    }, {
        key: 'createFormBuyInCredit',
        value: function createFormBuyInCredit() {
            var _this2 = this;

            var discountEpsilon = this.props.order.discount_sum;
            var discountPercent = this.props.order.discount_sum / (this.props.order.sum / 100);
            var promoCode = this.props.buyInCredit.promo_code === '' ? 'default' : this.props.buyInCredit.promo_code;
            var products = this.props.order.products.map(function (item, index) {
                var modifierOptionName = '';
                var sale = parseFloat(item.base_price * (discountPercent / 100)).toFixed(2);
                var price = parseFloat(item.base_price - sale).toFixed(2);
                discountEpsilon = discountEpsilon - sale * item.quantity;
                if (item.modifier_option_name !== null) {
                    modifierOptionName = item.modifier_option_name;
                }
                if (index === _this2.props.order.products.length) {
                    price = parseFloat(item.base_price - (sale + discountEpsilon / item.quantity)).toFixed(2);
                }
                return {
                    name: item.name + modifierOptionName,
                    quantity: item.quantity,
                    price: price,
                    vendorCode: item.id_yml
                };
            });
            tinkoff.create({
                shopId: this.props.buyInCredit.external_shop_id,
                showcaseId: this.props.buyInCredit.showcase_id,
                promoCode: promoCode,
                sum: parseFloat(this.props.order.sum - this.props.order.discount_sum).toFixed(2),
                orderNumber: this.props.order.order_number,
                items: products,
                values: {
                    contact: {
                        mobilePhone: this.props.user.phone,
                        email: this.props.user.phone
                    }
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var View = _helpers.ThemeHelper.getViewForComponent('PaymentList', null, { folderName: 'Order/PaymentList' });
            var payments = this.props.payments;
            if (this.props.buyInCreditActive && this.props.order.sum <= 500000 && this.props.order.sum >= 3000) {
                if (payments[0].slug !== 'buy_in_credit') {
                    payments.unshift({
                        id: 1,
                        slug: 'buy_in_credit',
                        lang_data_eng: 'Buy on credit',
                        lang_data_rus: 'Купи в кредит',
                        icon: config.apiHost + '/static_files/static/images/services/paytype.jpg',
                        big_icon: config.apiHost + '/static_files/static/images/services/paytype.jpg'
                    });
                }
                var buyInCreditOrder = _LocalStorageProxy2.default.getItem('buy_in_credit');
                if (buyInCreditOrder === 'true') {
                    payments = [{
                        id: 1,
                        slug: 'buy_in_credit',
                        lang_data_eng: 'Buy on credit',
                        lang_data_rus: 'Купи в кредит',
                        icon: config.apiHost + '/static_files/static/images/services/paytype.jpg',
                        big_icon: config.apiHost + '/static_files/static/images/services/paytype.jpg'
                    }];
                }
            }
            return _react3.default.createElement(View, {
                title: this.props.title,
                onChange: this.handleChange,
                payments: payments,
                slug: this.state.selectedSlug,
                slugText: this.state.selectedSlugText,
                slugImg: this.state.selectedSlugImg,
                additionalFieldText: this.state.additionalFieldText,
                onChangeAdditionalField: this.handleChangeAdditionalField,
                onShowAdditionalField: this.handleShowAdditionalField,
                refAdditionalField: function refAdditionalField(element) {
                    _this3._refAdditionalField = element;
                },
                warning: this.props.warning,
                lang: this.props.lang,
                currency: this.props.currency
            });
        }
    }]);
    return PaymentList;
}(_react2.Component), _class2.propTypes = {
    payments: _react2.PropTypes.array.isRequired,
    order: _react2.PropTypes.object.isRequired,
    getInstance: _react2.PropTypes.func,
    title: _react2.PropTypes.string,
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object.isRequired
}, _class2.defaultProps = {
    getInstance: function getInstance() {},
    title: null
}, _temp)) || _class));

exports.default = PaymentList;

function _inspect(input, depth) {
    var maxDepth = 4;
    var maxKeys = 15;

    if (depth === undefined) {
        depth = 0;
    }

    depth += 1;

    if (input === null) {
        return 'null';
    } else if (input === undefined) {
        return 'void';
    } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
        return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
    } else if (Array.isArray(input)) {
        if (input.length > 0) {
            if (depth > maxDepth) return '[...]';

            var first = _inspect(input[0], depth);

            if (input.every(function (item) {
                return _inspect(item, depth) === first;
            })) {
                return first.trim() + '[]';
            } else {
                return '[' + input.slice(0, maxKeys).map(function (item) {
                    return _inspect(item, depth);
                }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
            }
        } else {
            return 'Array';
        }
    } else {
        var keys = (0, _keys2.default)(input);

        if (!keys.length) {
            if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
                return input.constructor.name;
            } else {
                return 'Object';
            }
        }

        if (depth > maxDepth) return '{...}';
        var indent = '  '.repeat(depth - 1);
        var entries = keys.slice(0, maxKeys).map(function (key) {
            return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
        }).join('\n  ' + indent);

        if (keys.length >= maxKeys) {
            entries += '\n  ' + indent + '...';
        }

        if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
            return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
        } else {
            return '{\n  ' + indent + entries + '\n' + indent + '}';
        }
    }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/PaymentList/index.jsx
// module id = 1707
// module chunks = 0